<!--
/**
 * Single custom template (activation only, like story)
 *
 * @package ARS Webapp
 * @author René Schulze <schulze@thadeus-roth.de>
 */
 -->

<script setup>
    import { reactive, computed, onMounted } from 'vue';
    import { useRoute } from 'vue-router';
    import repository from '?/Composable/Repository';
    import { custom as customData } from '?/ProjectData';
    import { getAssetPath } from '?/Composable/Tools';

    // Initialization
    const route = useRoute();

    // Data
    const props = defineProps({
        station: {
            type: Object,
            required: true
        }
    });

    const slug = computed(() => {
         return route.meta.slug;
    });

    const state = reactive({
        station: props.station,
        stationVisible: false
    });

    // Custom setup logic
    onMounted(() => {
        state.stationVisible = props.station.visible;

        if (!props.station.done) {
            repository.activateStation(props.station.stationId);
        }
    });

    // Functions
    const data = (id) => {
        return customData.find((data) => {
            return data.id == id;
        });
    };

    const parseContent = (content) => {
        // If the content is a string, return it wrapped in a paragraph tag
        if (typeof content === 'string') {
            return `<p>${content}</p>`;
        }

        // If the content is an object, iterate through its keys and values
        if (typeof content === 'object' && content !== null) {
            return Object.entries(content)
                .map(([key, value]) => {
                    return `<h4>${key}</h4>${value}`;
                })
                .join('');
        }

        // Fallback for invalid input types
        return '';
    };
</script>

<template>
    <div id="station-custom-detail"
         class="station-detail station-custom-detail station-type__activation-only"
         v-if="state.stationVisible">
        <div class="station custom"
             :id="'custom-' + state.station.stationId">
            <figure class="station-image custom-image">
                <span class="station-image-wrapper custom-image-wrapper"
                      :style="'background-image: url(\'' + getAssetPath() + '/' + slug + '/custom-' + state.station.stationId + '.jpg\');'">
                    <img :src="getAssetPath() + '/' + slug + '/custom-' + data(state.station.stationId).author + '.jpg'"
                         alt="" />
                </span>
                <figcaption>
                    <h3 class="station-name custom-name"
                        v-html="data(state.station.stationId).title"></h3>
                </figcaption>
            </figure>
            <div class="station-description custom-description">
                <div class="long-description" v-html="data(state.station.stationId).longDesc"></div>
                <div class="station-content" v-html="parseContent(data(state.station.stationId).content)"></div>
            </div>
        </div>
    </div>
    <div id="station-custom-detail" class="station-detail station-custom-detail" v-else>
        {{ $t('custom.unavailable') }}
    </div>
</template>
